import Dialog, { DialogProps } from "./dialog"
import { Form, useForm } from "@/components/form"

export interface ConfirmDialogProps extends DialogProps {
}

export default function ConfirmDialog({
    children,
    ...props
}: ConfirmDialogProps) {
    return <Dialog {...props} >
        {children}
    </Dialog>
}

export interface ConfirmDialogContentProps {
    title?: string,
    description?: string,
    confirmText?: string,
    cancelText?: string,
    onConfirm?: () => Promise<any> | any
}

function ConfirmDialogContent({
    title = "",
    description = "",
    confirmText = "Aceptar",
    cancelText = "Cancelar",
    onConfirm = () => { },
}: ConfirmDialogContentProps) {
    const confirmModalForm = useForm({
        onSubmit: async ({ meta }) => {
            if (meta === "cancel") {
            } else {
                await onConfirm();
            }
        },
        defaultValues: {} as any,
        submitOnce: true,
        closeModalOnSubmit: true,
        preventCloseModalWhileSubmitting: false
    })

    return <Form form={confirmModalForm}>
        <Dialog.Title>{title}</Dialog.Title>
        <Dialog.Content>
            <Dialog.ContentText>
                {description}
            </Dialog.ContentText>
        </Dialog.Content>
        <Dialog.Actions>
            <Form.SubmitButton name="cancel" variant="text" sx={{ width: "100px" }}>
                {cancelText}
            </Form.SubmitButton>
            <Form.SubmitButton sx={{ width: "100px" }}>
                {confirmText}
            </Form.SubmitButton>
        </Dialog.Actions>
    </Form>
}

ConfirmDialog.Content = ConfirmDialogContent;